var map = {
	"./favicon/logo": 27,
	"./favicon/logo.png": 27,
	"./favicon/safari-pinned-tab": 28,
	"./favicon/safari-pinned-tab.svg": 28,
	"./placeholder/placeholder-16x9": 29,
	"./placeholder/placeholder-16x9.jpg": 29,
	"./placeholder/placeholder-1x1": 30,
	"./placeholder/placeholder-1x1.jpg": 30,
	"./placeholder/placeholder-2x1": 31,
	"./placeholder/placeholder-2x1.jpg": 31,
	"./placeholder/placeholder-2x3": 32,
	"./placeholder/placeholder-2x3.jpg": 32,
	"./placeholder/placeholder-32x9": 33,
	"./placeholder/placeholder-32x9.jpg": 33,
	"./placeholder/placeholder-3x2": 34,
	"./placeholder/placeholder-3x2.jpg": 34,
	"./placeholder/placeholder-3x4": 35,
	"./placeholder/placeholder-3x4.jpg": 35,
	"./placeholder/placeholder-8x9": 36,
	"./placeholder/placeholder-8x9.jpg": 36,
	"./schema/logo": 37,
	"./schema/logo.png": 37,
	"./social_sharing/facebook": 38,
	"./social_sharing/facebook.png": 38,
	"./social_sharing/twitter": 39,
	"./social_sharing/twitter.png": 39,
	"./template/alert-widget-bg": 40,
	"./template/alert-widget-bg.png": 40,
	"./template/arrow-down": 7,
	"./template/arrow-down.png": 7,
	"./template/arrow-down.svg": 93,
	"./template/arrow-left": 8,
	"./template/arrow-left.png": 8,
	"./template/arrow-left.svg": 94,
	"./template/arrow-right": 9,
	"./template/arrow-right.png": 9,
	"./template/arrow-right.svg": 95,
	"./template/arrow-up": 10,
	"./template/arrow-up.png": 10,
	"./template/arrow-up.svg": 96,
	"./template/download": 11,
	"./template/download.png": 11,
	"./template/download.svg": 97,
	"./template/email": 41,
	"./template/email.svg": 41,
	"./template/icon--download": 42,
	"./template/icon--download.svg": 42,
	"./template/icon--link-external": 43,
	"./template/icon--link-external.svg": 43,
	"./template/icon--link-internal": 44,
	"./template/icon--link-internal.svg": 44,
	"./template/icon--map-marker_smaller": 45,
	"./template/icon--map-marker_smaller.svg": 45,
	"./template/icon--modular-tool": 46,
	"./template/icon--modular-tool-orange": 47,
	"./template/icon--modular-tool-orange.svg": 47,
	"./template/icon--modular-tool.svg": 46,
	"./template/logo": 48,
	"./template/logo.svg": 48,
	"./template/logos/placeholder-logo-square": 49,
	"./template/logos/placeholder-logo-square.png": 49,
	"./template/logos/placeholder-logo-tall": 50,
	"./template/logos/placeholder-logo-tall.png": 50,
	"./template/logos/placeholder-logo-wide": 51,
	"./template/logos/placeholder-logo-wide.png": 51,
	"./template/map-pin": 52,
	"./template/map-pin.png": 52,
	"./template/placeholder": 53,
	"./template/placeholder.png": 53,
	"./template/search": 54,
	"./template/search.svg": 54,
	"./template/select-arrow-down": 12,
	"./template/select-arrow-down.png": 12,
	"./template/select-arrow-down.svg": 98,
	"./template/tick": 13,
	"./template/tick.png": 13,
	"./template/tick.svg": 99,
	"./template/video-not-allowed": 55,
	"./template/video-not-allowed.jpg": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;